/* ============================================================
   STORE 2 — Custom Add-to-Cart experience
   AJAX add (no redirect) + button morph + fly-to-cart +
   badge bounce + slide-in toast. Overrides Dawn's default.
============================================================ */
(function () {
  var cfg = window.s2CartConfig || {};
  var ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  var CART_URL = (window.routes && window.routes.cart_url) || '/cart';
  var MONEY = (cfg.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');

  /* ---------- money formatting ---------- */
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    function group(dec, t, s) {
      var n = (cents / 100.0).toFixed(dec);
      var parts = n.split('.');
      var intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return intp + (parts[1] ? s + parts[1] : '');
    }
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, name) {
      switch (name) {
        case 'amount': return group(2, ',', '.');
        case 'amount_no_decimals': return group(0, ',', '.');
        case 'amount_with_comma_separator': return group(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(0, '.', ',');
        case 'amount_with_space_separator': return group(2, ' ', ',');
        default: return group(2, ',', '.');
      }
    });
  }

  /* ---------- escaping ---------- */
  /* Everything below builds markup with innerHTML, so any value that
     originates from product data goes through here first. */
  var ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ESC[c]; });
  }

  /* ---------- icons ---------- */
  var SPINNER = '<span class="s2-atc-spinner" aria-hidden="true"></span>';
  var CHECK = '<svg class="s2-atc-check" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5"/></svg>';
  var GIFT = '<svg class="s2-atc-gift" viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var MAX_TOASTS = 3;

  /* ---------- intercept add-to-cart submits (capture phase, before Dawn) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    // Only real add-to-cart forms: must post to /cart/add, have an "add" button
    // and a variant id. Excludes the Shop Pay installment / payment forms.
    if (action.indexOf('/cart/add') === -1) return;
    if (!form.querySelector('[name="add"]')) return;
    if (!form.querySelector('[name="id"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCart(form);
  }, true);

  var busy = false;

  function addToCart(form) {
    if (busy) return;
    busy = true;
    var btn = form.querySelector('[type="submit"], [name="add"]');
    setLoading(btn);

    var body = new FormData(form);

    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (item.status) { // error object
          setError(btn, item.description || item.message || 'Unavailable');
          busy = false;
          return;
        }
        setSuccess(btn);
        flyToCart(form, item);
        refreshCart();
        showToast(item);
        closeQuickAdd(form);
        setTimeout(function () { busy = false; }, 400);
      })
      .catch(function () { setError(btn, 'Try again'); busy = false; });
  }

  /* ---------- button states ---------- */
  function setLoading(btn) {
    if (!btn) return;
    btn.dataset.s2Html = btn.innerHTML;
    btn.style.pointerEvents = 'none';
    btn.classList.add('s2-atc-busy');
    btn.innerHTML = SPINNER;
  }
  function setSuccess(btn) {
    if (!btn) return;
    btn.classList.remove('s2-atc-busy');
    btn.classList.add('s2-atc-done');
    btn.innerHTML = CHECK + '<span class="s2-atc-done-label">Added</span>';
    setTimeout(function () { restore(btn); }, 1700);
  }
  function setError(btn, msg) {
    if (!btn) return;
    btn.classList.remove('s2-atc-busy');
    btn.classList.add('s2-atc-error');
    btn.innerHTML = '<span>' + msg + '</span>';
    setTimeout(function () { restore(btn); }, 1900);
    toast({ error: true, title: msg });
  }
  function restore(btn) {
    if (!btn || !btn.dataset.s2Html) return;
    btn.innerHTML = btn.dataset.s2Html;
    btn.classList.remove('s2-atc-done', 's2-atc-error', 's2-atc-busy');
    btn.style.pointerEvents = '';
    delete btn.dataset.s2Html;
  }

  /* ---------- fly-to-cart ---------- */
  function flyToCart(form, item) {
    var cart = document.querySelector('[data-s2-cart-link]');
    if (!cart || !item.image) { bumpBadge(); return; }

    // source: nearest product image, else the button
    var scope = form.closest('.s2-product-card, .product, .quick-add-modal, .card-wrapper, .card') || form;
    var srcEl = scope.querySelector('img') || form.querySelector('[type="submit"], [name="add"]');
    if (!srcEl) { bumpBadge(); return; }

    var s = srcEl.getBoundingClientRect();
    var t = cart.getBoundingClientRect();
    var img = document.createElement('img');
    img.src = item.image;
    img.className = 's2-fly-img';
    var size = Math.min(120, Math.max(60, s.width * 0.5));
    img.style.width = size + 'px';
    img.style.height = size + 'px';
    img.style.left = (s.left + s.width / 2 - size / 2) + 'px';
    img.style.top = (s.top + s.height / 2 - size / 2) + 'px';
    document.body.appendChild(img);

    var dx = (t.left + t.width / 2) - (s.left + s.width / 2);
    var dy = (t.top + t.height / 2) - (s.top + s.height / 2);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        img.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.12) rotate(24deg)';
        img.style.opacity = '0.2';
      });
    });
    img.addEventListener('transitionend', function () {
      img.remove();
      bumpBadge();
    });
    setTimeout(function () { if (img.parentNode) { img.remove(); bumpBadge(); } }, 1000);
  }

  function bumpBadge() {
    document.querySelectorAll('[data-s2-cart-badge]').forEach(function (b) {
      b.classList.remove('s2-cart-badge--bump');
      void b.offsetWidth;
      b.classList.add('s2-cart-badge--bump');
    });
  }

  /* ---------- refresh cart count ---------- */
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        document.querySelectorAll('[data-s2-cart-badge]').forEach(function (b) {
          b.textContent = count;
          b.classList.toggle('s2-cart-badge--zero', count === 0);
        });
        document.querySelectorAll('[data-s2-cart-text]').forEach(function (t) {
          t.textContent = 'Cart, ' + count + (count === 1 ? ' item' : ' items');
        });
      });
  }

  /* ---------- toast ---------- */
  var wrap;
  function getWrap() {
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 's2-cart-toast-wrap';
      document.body.appendChild(wrap);
    }
    return wrap;
  }

  function showToast(item) {
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    toast({
      image: item.image,
      title: item.product_title || item.title,
      variant: variant,
      price: formatMoney(item.final_line_price != null ? item.final_line_price : item.final_price),
      qty: item.quantity
    });
  }

  function toast(data) {
    var w = getWrap();

    /* Cap the stack — adding a product can queue a product toast and a
       gift toast back to back, and older ones are no longer useful. */
    var live = w.querySelectorAll('.s2-cart-toast:not(.is-out)');
    for (var i = 0; i <= live.length - MAX_TOASTS; i++) dismiss(live[i]);

    var el = document.createElement('div');
    el.className = 's2-cart-toast' +
      (data.error ? ' s2-cart-toast--error' : '') +
      (data.gift ? ' s2-cart-toast--gift' : '');

    var media = '';
    if (data.error) {
      media = '<span class="s2-cart-toast-badge s2-cart-toast-badge--err">!</span>';
    } else if (data.image) {
      media = '<span class="s2-cart-toast-thumb">' +
                '<img src="' + esc(data.image) + '" alt="" loading="lazy">' +
                (data.gift ? '<span class="s2-cart-toast-thumb-tag">Free</span>' : '') +
              '</span>';
    } else {
      media = '<span class="s2-cart-toast-badge">' + (data.gift ? GIFT : CHECK) + '</span>';
    }

    var head;
    if (data.error) {
      head = '<span class="s2-cart-toast-eyebrow s2-cart-toast-eyebrow--err">Couldn\'t add</span>';
    } else if (data.gift) {
      head = '<span class="s2-cart-toast-eyebrow s2-cart-toast-eyebrow--gift">' + GIFT + ' ' + esc(data.badge || 'Free gift') + ' added</span>';
    } else {
      head = '<span class="s2-cart-toast-eyebrow"><svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5"/></svg> Added to cart</span>';
    }

    var meta = '';
    if (data.gift) {
      meta = '<span class="s2-cart-toast-meta">Included with your order &nbsp;·&nbsp; <b>Free</b></span>';
    } else if (!data.error) {
      var bits = [];
      if (data.variant) bits.push(esc(data.variant));
      if (data.qty && data.qty > 1) bits.push('Qty ' + esc(data.qty));
      if (data.price) bits.push(esc(data.price));
      meta = '<span class="s2-cart-toast-meta">' + bits.join(' &nbsp;·&nbsp; ') + '</span>';
    }

    /* The gift toast is informational — it never competes with the
       product toast's calls to action. */
    var actions = (data.error || data.gift) ? '' :
      '<div class="s2-cart-toast-actions">' +
        '<a class="s2-btn s2-btn--outline s2-cart-toast-btn" href="' + CART_URL + '">View cart</a>' +
        '<a class="s2-btn s2-btn--primary s2-cart-toast-btn" href="/checkout">Checkout</a>' +
      '</div>';

    el.innerHTML =
      '<button class="s2-cart-toast-close" aria-label="Dismiss">&times;</button>' +
      '<div class="s2-cart-toast-top">' +
        media +
        '<div class="s2-cart-toast-copy">' +
          head +
          '<span class="s2-cart-toast-title">' + esc(data.title) + '</span>' +
          meta +
        '</div>' +
      '</div>' +
      actions +
      '<span class="s2-cart-toast-progress"></span>';

    w.appendChild(el);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-in'); });
    });

    var life = data.error ? 3200 : (data.gift ? 4200 : 5200);
    var timer = setTimeout(function () { dismiss(el); }, life);
    var prog = el.querySelector('.s2-cart-toast-progress');
    if (prog) { prog.style.transition = 'transform ' + life + 'ms linear'; requestAnimationFrame(function () { requestAnimationFrame(function () { prog.style.transform = 'scaleX(0)'; }); }); }

    el.addEventListener('mouseenter', function () { clearTimeout(timer); if (prog) prog.style.transition = 'none'; });
    el.addEventListener('mouseleave', function () { timer = setTimeout(function () { dismiss(el); }, 1600); });
    el.querySelector('.s2-cart-toast-close').addEventListener('click', function () { clearTimeout(timer); dismiss(el); });
  }

  function dismiss(el) {
    el.classList.remove('is-in');
    el.classList.add('is-out');
    el.addEventListener('transitionend', function () { el.remove(); });
    setTimeout(function () { if (el.parentNode) el.remove(); }, 500);
  }

  /* ---------- close quick-add modal if open ---------- */
  function closeQuickAdd(form) {
    var modal = form.closest('quick-add-modal');
    if (modal && typeof modal.hide === 'function') { try { modal.hide(); } catch (e) {} }
  }

  /* ---------- public surface ----------
     s2-free-gift.js reuses this toast rather than shipping its own,
     and asks for a badge refresh after it changes the cart itself. */
  window.s2Toast = toast;
  document.addEventListener('s2:cart:refresh', function () { refreshCart(); });
})();
